import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ROUTES_club, ROUTES_players, ROUTES_restaurant } from './side-nav-route';
import { CommonService } from '../../services/common.service';

@Component({
  selector: 'app-side-nav',
  templateUrl: './side-nav.component.html',
  styleUrls: ['./side-nav.component.scss']
})
export class SideNavComponent implements OnInit {
  public menuItems: any;
  checkurl: any;
  ProfileDetails: any = [];
  // isFolded: boolean;
  // isSideNavDark: boolean;

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private csObj: CommonService,
  ) {



  }

  ngOnInit(): void {
    let chech = window.setInterval(() => {
      let user = localStorage.getItem("currentUser");

      let currentUser = JSON.parse(user);
      currentUser = currentUser?.userDetails?.userType ? currentUser?.userDetails?.userType : currentUser?.userType;
      if(!user){
        clearInterval(chech);
      }
      this.checkurl = this.router.url
      if (this.checkurl != "/organization_dash" && this.checkurl != "/team_dash" && this.checkurl != "/restaurant_dash") {
        (<HTMLInputElement>document.getElementById('usercustomheader')).classList.add('usercustomheader');
      } else {
        (<HTMLInputElement>document.getElementById('usercustomheader')).classList.remove('usercustomheader');
      }
    }, 100)
    this.getProfileDetails();
  }


  // ********************************************************************************************
  // getProfileDetails END
  getProfileDetails() {
    try {
      this.csObj.getProfile().subscribe((res: any) => {
        this.ProfileDetails = res;
        if (res.output.userData.userType === 2) {
          this.menuItems = ROUTES_club.filter(menuItem => menuItem);
        } else if (res.output.userData.userType === 3) {
          this.menuItems = ROUTES_players.filter(menuItem => menuItem);
        } else if (res.output.userData.userType === 4) {
          this.menuItems = ROUTES_restaurant.filter(menuItem => menuItem);
        }

      })
    }
    catch (e) { }
  }
  // getProfileDetails END
  // ********************************************************************************************


  manageSettingClick(path: any) {
    // this.router.navigateByUrl(path, { skipLocationChange: true }).then(() => {
    //   // this.router.navigate(["/manageTeams"])
    //   window.location.href = path;
    // });
  }

}

